import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CourseCachedResourceService } from './course-cached-resource.service';
import { CourseResourceService } from './course-resource.service';
import { ApiResourceModule } from '../api-resource/api-resource.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ApiResourceModule],
  exports: [],
  providers: [CourseResourceService, CourseCachedResourceService],
})
export class CourseResourceModule {}
